module.exports = __webpack_public_path__ + "assets/img/store-phone-4.a565acc8.png";